import React, { useEffect, useState } from "react";
import Cart from "../../components/Cart";
import { Backdrop, CircularProgress, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useArgusAuth } from "../../hooks/useArgusAuth";
import { useArgusCart } from "../../contexts/ArgusCartContext";


const CartPage = ({ genericDataLoaded, genericPageContent }) => {
  const {
    pricingData,
    productData,
    cartNettTotal,
    settlementAmount,
    cartVatAmount,
    cartGrandTotal,
    vat,
    items,
    createCheckout,
    isLoading,
    goBack,
    totalItems,
    removeItem,
    setItems,
    emptyCart,
    clearCartMetadata,
    updateItemQuantity
  } = useArgusCart();
  const { isAuthenticated } = useArgusAuth();
  const navigate = useNavigate();


  const authorizedPageLoad = async () => {
    await Promise.all([]);
  };

  useEffect(() => {
    if (genericDataLoaded === true && isLoading === false) {
      if (isAuthenticated === false) {
      } else {
        authorizedPageLoad();
      }
    }
  }, [isAuthenticated, genericDataLoaded]);

  return (
    <Container maxWidth="lg">
      <Cart
        loading={isLoading}
        cartNettTotal={cartNettTotal}
        settlementAmount={settlementAmount}
        vatAmount={cartVatAmount}
        total={cartGrandTotal}
        productData={productData}
        pricingData={pricingData}
        customerCategory={genericPageContent?.customerCategory}
        createCheckout={createCheckout}
        goBack={goBack}
        items={items}
        setItems={setItems}
        removeItem={removeItem}
        emptyCart={emptyCart}
        clearCartMetadata={clearCartMetadata}
        updateItemQuantity={updateItemQuantity}
        totalItems={totalItems}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
};
export default CartPage;
